import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderLegStopTypesAdapter = getAdapter({ idFieldName: 'value' });

const orderLegStopTypesSlice = createSlice({
  name: 'orderLegStopTypes',
  initialState: orderLegStopTypesAdapter.getInitialState(),
  reducers: {
    setOrderLegStopTypes: (state, { payload: { orderLegStopTypes } }) => {
      orderLegStopTypesAdapter.setAll(state, orderLegStopTypes);
    },
  },
});

const selectors = orderLegStopTypesAdapter.getSelectors(({ orderLegStopTypes }) => orderLegStopTypes);

export const getOrderLegStopTypes = (state) => selectors.selectAll(state);

export const {
  setOrderLegStopTypes
} = orderLegStopTypesSlice.actions;

export default orderLegStopTypesSlice.reducer;